export const readingType = [
  { value: 1, label: 'BGM' },
  { value: 2, label: 'CGM' },
];

export const initialState = {
  readingType: readingType[1],
  startDate: null,
  endDate: null,
};
